module.exports = __webpack_public_path__ + "static/media/3il.28b0101d.png";